import clsx from 'clsx';
import PropTypes from 'prop-types';

import './divider.scss';

export function Divider({ className }) {
  return <hr className={clsx('sb-Divider', className)} />;
}

Divider.propTypes = {
  className: PropTypes.string,
};

Divider.defaultProps = {
  className: undefined,
};
